import actionConsts from './../constants/actions';
import store from './../store/store';

const meetingRecieved = () => ({
    type: actionConsts.MEETING_RECIEVED,
});

export const endMeeting = (payload) => {
    store.dispatch({
        type: actionConsts.END_MEETING
    })
};

export const stopMeetingNotification = () => {
    store.dispatch(meetingRecieved());
}

export const decreaseMeetingTimeLeft = () => {
    store.dispatch({
        type: actionConsts.COUNT_DOWN_TIMER
    });
}

// export const startMeeting = (meetingId) => {
//     store.dispatch(addMeeting(meetingId));
// }

export const incomingMeetingNotification = () => ({
    type: actionConsts.INCOMING_MEETING_NOTIFICATION,
});



// WEBPACK FOOTER //
// /src/actions/meeting.js